<template>
    <div class="main">
        <div v-for="(item, index) in lang" :key="index">
            <!-- 活动的地方 -->
            <div class="sudoku-container">
                <section>
                    <Monopoly @handleFinish="handleFinish" @change="lotteryChange" :awardList="awardList" :isOnRound="isOnRound" :bingosList="bingoList"></Monopoly>
                </section>
            </div>
            <!-- 右上角的！ -->
            <div class="tipBtn" @click="isTip = true">
                <img src="@/assets/images/illustrate_entrance.png" alt="" />
            </div>
            <!-- 右上角说明  -->
            <div class="loggedWrap" v-show="isTip">
                <div class="logged">
                    <div class="btn" @click="isTip = false"><img src="@/assets/images/illustrate_board_x.png" alt="" /></div>
                    <div class="tipText">
                        <h3>{{ item[0] }}</h3>
                        <div>
                            <span v-html="detailMsg"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { myHTTP } from '../utils/net'
import queryString from 'query-string'
import Monopoly from '@/components/monopoly'
import { lang } from '@/tool/archeroLang'
import arrList from '@/data/prize.js'
import { v4 as uuidv4 } from 'uuid'
var parsed = queryString.parse(location.search || '') || {}
export default {
    props: ['language', 'isOnRound','bingoList','isTips'],
    components: {
        Monopoly
    },
    data() {
        let loginURL = 'https://test-giftcode-archero.habby.com/api/v1/thirdparty/auth'
        if (window.location.href.indexOf('https://test-h5-archero') === 0) {
            loginURL = 'https://test-giftcode-archero.habby.com/api/v1/thirdparty/auth'
        } else if (window.location.href.indexOf('https://h5-archero') === 0) {
            loginURL = 'https://giftcode-archero.habby.com/api/v1/thirdparty/auth'
        }

        return {
            loginURL,
            userId: '',
            d: '',
            isTip: false, //说明
            isLogin: false,

            lang: [{}],
            detailMsg: '',
            awardList: []
        }
    },
    created() {
        this.initWard()
        this.isTip = this.isTips
        // if (!localStorage.getItem('d')) {
        //     // this.isLogin = true //为true的时候需要登录 打开登录界面
        //     this.newInit()
        // } else {
        //     this.init()
        // }
        // if (!localStorage.getItem('uuid')) {
        //     localStorage.setItem('uuid', uuidv4())
        // } else {
        //     this.init()
        // }
        for (var i in lang) {
            this.lang[0][i] = lang[i][this.language]
        }
    },
    mounted() {
        this.detailMsg = this.lang[0][1]
        // window.fbAsyncInit = () => {
        //     FB.init({
        //         appId: '250812872464647',
        //         cookie: true, // Enable cookies to allow the server to access the session.
        //         xfbml: true, // Parse social plugins on this webpage.
        //         version: 'v14.0' // Use this Graph API version for this call.
        //     })
        // }
    },
    methods: {
        handleFinish(val) {
            this.$emit('handleFinish', val)
        },
        initWard() {
            setTimeout(() => {
                this.awardList = arrList
            }, 0)
        },
        lotteryChange(action, item) {
            // start fin 的行为反馈
            // console.log(action, item)
        },
        onLogin(loginType) {
            location.href = this.loginURL + '/' + loginType
        },
        newInit() {
            myHTTP.get('/api/v1/thirdparty/anonymouslogin').then(res => {
                console.log(res, '~~~~res')
                if (res.data.code == 0) {
                    localStorage.setItem('d', res.data.data.d)
                    this.init()
                } else {
                    this.$Message.error(data.error)
                }
            })
        },
    }
}
</script>

<style scoped lang="less">
@import url('../assets/styles/reset.css');
.sudoku-container {
    width: 100%;
    height: 100vh;
    display: inline-block;
    section {
        width: 100%;
        height: 100%;
        margin-top: 30.28rem;
    }
}

.main {
    position: relative;
    height: 100vh;
    width: 100%;
    // background: url('../assets/images/anniversarybg.jpg') 100% 100% no-repeat;
    // background-size: 100% 100%;
    text-align: center;
    line-height: 1;

    .tipBtn {
        position: absolute;
        top: 0;
        right: 3.25rem;
        img {
            width: 6.25rem;
        }
    }

    .loggedWrap {
        width: 100%;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.004);
        line-height: 1.2;
        .logged {
            position: absolute;
            width: 90%;
            height: 68.75vh;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: url('../assets/images/illustrate_board_bg.png') 100% 100% no-repeat;
            background-size: 100% 100%;
            text-align: center;
            border-radius: 1.5rem;
            padding: 1.125rem 2.125rem 3.25rem;
            overflow: scroll;
        }
        .btn {
            position: absolute;
            top: 0;
            right: 0;
            height: 4rem;
            img {
                width: 6rem;
            }
        }
        .tipText {
            height: 100%;
            display: flex;
            flex-flow: column;
            color: #ffffff;
            font-size: 2.25rem;
            font-weight: 400;
            padding: 3rem 4rem;
            text-align: left;
            line-height: 1.5;
            h3 {
                text-align: center;
                padding: 5rem 0 4rem;
                font-size: 3rem;
            }
            div {
                flex: 1;
                padding: 3.75rem 1.875rem;
                background: #0a741e;
                border-radius: 1.5rem;
                overflow: scroll;
            }
        }

        .ftl {
            padding: 0 4.25rem;
            .beLogin {
                padding-top: 5.625rem;
                color: #393939;
                font-size: 2.25rem;
            }
            .wayLoginWrap {
                display: flex;
                background: #3975ea;
                border-radius: 5rem;
                overflow: hidden;
                padding: 1rem 0;
                height: 9.875rem;

                div {
                    display: flex;
                    justify-content: space-around;
                    flex-direction: column;
                    align-items: center;
                    word-break: break-all;
                    color: white;
                    font-size: 2.625rem;
                    line-height: 1.3;
                    padding-left: 3rem;
                    padding-right: 3rem;
                }
                span {
                    padding-left: 2rem;
                    img {
                        width: 7.875rem;
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/main.vue